"use strict";
/**
 * Dictionary API Client
 * Handles waste code and waste process dictionary data from CarboWaste API
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryApiClient = void 0;
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var endpoints_1 = require("../config/endpoints");
/**
 * Default localization function (returns keys as-is)
 */
var defaultLocalization = function (key) { return key; };
var DictionaryApiClient = /** @class */ (function () {
    function DictionaryApiClient(config, localizationFn) {
        var _a;
        this.config = config;
        this.localize = localizationFn || defaultLocalization;
        this.endpoints = (0, endpoints_1.createCarboWasteEndpoints)(config.baseUrl);
        if ((_a = config.appInsights) === null || _a === void 0 ? void 0 : _a.instrumentationKey) {
            this.appInsights = new applicationinsights_web_1.ApplicationInsights({
                config: {
                    instrumentationKey: config.appInsights.instrumentationKey
                }
            });
            this.appInsights.loadAppInsights();
        }
    }
    /**
     * Get waste process data
     */
    DictionaryApiClient.prototype.getWasteProcessData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, result, error_1, isLocalhost, errorMessage;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 3, , 4]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'DictionaryApi_GetWasteProcess_Started',
                            properties: {
                                endpoint: this.endpoints.WasteProcessList,
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        return [4 /*yield*/, fetch(this.endpoints.WasteProcessList, {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })];
                    case 1:
                        response = _e.sent();
                        if (!response.ok) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'DictionaryApi_GetWasteProcess_HttpError',
                                properties: {
                                    status: response.status.toString(),
                                    statusText: response.statusText,
                                    endpoint: this.endpoints.WasteProcessList
                                }
                            });
                            throw new Error("".concat(this.localize('api_error_waste_process'), ": ").concat(response.status, " ").concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        result = _e.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'DictionaryApi_GetWasteProcess_Success',
                            properties: {
                                endpoint: this.endpoints.WasteProcessList,
                                resultCount: Array.isArray(result) ? result.length.toString() : '1'
                            }
                        });
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _e.sent();
                        isLocalhost = this.endpoints.WasteProcessList.includes('localhost') ||
                            this.endpoints.WasteProcessList.includes('127.0.0.1');
                        errorMessage = this.localize('api_error_unknown');
                        if (error_1 instanceof TypeError && error_1.message.includes('Failed to fetch')) {
                            errorMessage = isLocalhost ?
                                this.localize('api_error_connection_local') :
                                this.localize('api_error_connection_azure');
                        }
                        else if (error_1 instanceof Error && error_1.message.includes(this.localize('api_error_waste_process'))) {
                            errorMessage = error_1.message;
                        }
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackException({
                            exception: error_1,
                            properties: {
                                method: 'getWasteProcessData',
                                endpoint: this.endpoints.WasteProcessList,
                                isLocalhost: isLocalhost.toString(),
                                errorType: error_1.name || 'unknown'
                            }
                        });
                        throw new Error(errorMessage);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get waste code data with pagination
     */
    DictionaryApiClient.prototype.getWasteCodeData = function () {
        return __awaiter(this, arguments, void 0, function (pageSize, pageNumber) {
            var url, response, result, error_2, isLocalhost, errorMessage;
            var _a, _b, _c, _d;
            if (pageSize === void 0) { pageSize = 100; }
            if (pageNumber === void 0) { pageNumber = 1; }
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 3, , 4]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'DictionaryApi_GetWasteCode_Started',
                            properties: {
                                endpoint: this.endpoints.WasteCodeList,
                                pageSize: pageSize.toString(),
                                pageNumber: pageNumber.toString(),
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        url = new URL(this.endpoints.WasteCodeList);
                        url.searchParams.append('pageSize', pageSize.toString());
                        url.searchParams.append('pageNumber', pageNumber.toString());
                        return [4 /*yield*/, fetch(url.toString(), {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })];
                    case 1:
                        response = _e.sent();
                        if (!response.ok) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'DictionaryApi_GetWasteCode_HttpError',
                                properties: {
                                    status: response.status.toString(),
                                    statusText: response.statusText,
                                    endpoint: url.toString(),
                                    pageSize: pageSize.toString(),
                                    pageNumber: pageNumber.toString()
                                }
                            });
                            throw new Error("".concat(this.localize('api_error_waste_code'), ": ").concat(response.status, " ").concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        result = _e.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'DictionaryApi_GetWasteCode_Success',
                            properties: {
                                endpoint: url.toString(),
                                pageSize: pageSize.toString(),
                                pageNumber: pageNumber.toString(),
                                resultCount: result && result.items ?
                                    result.items.length.toString() :
                                    (Array.isArray(result) ? result.length.toString() : '1')
                            }
                        });
                        return [2 /*return*/, result];
                    case 3:
                        error_2 = _e.sent();
                        isLocalhost = this.endpoints.WasteCodeList.includes('localhost') ||
                            this.endpoints.WasteCodeList.includes('127.0.0.1');
                        errorMessage = this.localize('api_error_unknown');
                        if (error_2 instanceof TypeError && error_2.message.includes('Failed to fetch')) {
                            errorMessage = isLocalhost ?
                                this.localize('api_error_connection_local') :
                                this.localize('api_error_connection_azure');
                        }
                        else if (error_2 instanceof Error && error_2.message.includes(this.localize('api_error_waste_code'))) {
                            errorMessage = error_2.message;
                        }
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackException({
                            exception: error_2,
                            properties: {
                                method: 'getWasteCodeData',
                                endpoint: this.endpoints.WasteCodeList,
                                pageSize: pageSize.toString(),
                                pageNumber: pageNumber.toString(),
                                isLocalhost: isLocalhost.toString(),
                                errorType: error_2.name || 'unknown'
                            }
                        });
                        throw new Error(errorMessage);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all waste code data with automatic pagination
     */
    DictionaryApiClient.prototype.getAllWasteCodeData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allData, pageNumber, pageSize, hasMoreData, response, error_3, isLocalhost, errorMessage;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'DictionaryApi_GetAllWasteCode_Started',
                            properties: {
                                endpoint: this.endpoints.WasteCodeList,
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        allData = [];
                        pageNumber = 1;
                        pageSize = 50;
                        hasMoreData = true;
                        _e.label = 1;
                    case 1:
                        if (!hasMoreData) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getWasteCodeData(pageSize, pageNumber)];
                    case 2:
                        response = _e.sent();
                        // Check if API returns paginated format
                        if (response && response.items && Array.isArray(response.items)) {
                            allData = allData.concat(response.items);
                            hasMoreData = response.hasNextPage || response.items.length === pageSize;
                        }
                        else if (Array.isArray(response)) {
                            // If API returns array directly
                            allData = allData.concat(response);
                            hasMoreData = response.length === pageSize;
                        }
                        else {
                            // Single object or no data
                            if (response)
                                allData.push(response);
                            hasMoreData = false;
                        }
                        pageNumber++;
                        // Safety limit to prevent infinite loop
                        if (pageNumber > 100) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'DictionaryApi_GetAllWasteCode_PaginationLimitReached',
                                properties: {
                                    endpoint: this.endpoints.WasteCodeList,
                                    totalPages: pageNumber.toString(),
                                    totalRecords: allData.length.toString()
                                }
                            });
                            return [3 /*break*/, 5];
                        }
                        if (!hasMoreData) return [3 /*break*/, 4];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4: return [3 /*break*/, 1];
                    case 5:
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'DictionaryApi_GetAllWasteCode_Success',
                            properties: {
                                endpoint: this.endpoints.WasteCodeList,
                                totalPages: (pageNumber - 1).toString(),
                                totalRecords: allData.length.toString()
                            }
                        });
                        return [2 /*return*/, allData];
                    case 6:
                        error_3 = _e.sent();
                        isLocalhost = this.endpoints.WasteCodeList.includes('localhost') ||
                            this.endpoints.WasteCodeList.includes('127.0.0.1');
                        errorMessage = this.localize('api_error_unknown');
                        if (error_3 instanceof TypeError && error_3.message.includes('Failed to fetch')) {
                            errorMessage = isLocalhost ?
                                this.localize('api_error_connection_local') :
                                this.localize('api_error_connection_azure');
                        }
                        else if (error_3 instanceof Error &&
                            (error_3.message.includes(this.localize('api_error_waste_code')) ||
                                error_3.message.includes(this.localize('api_error_all_waste_code')))) {
                            errorMessage = error_3.message;
                        }
                        else {
                            errorMessage = this.localize('api_error_all_waste_code');
                        }
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackException({
                            exception: error_3,
                            properties: {
                                method: 'getAllWasteCodeData',
                                endpoint: this.endpoints.WasteCodeList,
                                isLocalhost: isLocalhost.toString(),
                                errorType: error_3.name || 'unknown'
                            }
                        });
                        throw new Error(errorMessage);
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return DictionaryApiClient;
}());
exports.DictionaryApiClient = DictionaryApiClient;
//# sourceMappingURL=DictionaryApiClient.js.map